<template>
  <modal
    v-slot="{ data }"
    name="inboxMessage"
    modal-style="compact"
  >
    <inbox-message
      :message="data.message"
      :message-id="data.messageId"
      :on-delete="data.onDelete"
    />
  </modal>
</template>

<script>
  import InboxMessage from './inbox-message/index.vue';

  export default {
    name: 'InboxMessageModal',

    components: {
      InboxMessage
    }
  };
</script>
